import View from './view'

import {MemberList} from '../../redux/organizations'

type NewUsers = {
  firstName?: string
  lastName?: string
  email?: string
}

type FormValues = {
  addUsers: string
  newUsers: NewUsers[]
}

type Props = {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  members?: MemberList[]
  formValues: FormValues
  usersToRemove: string[]
  handleSubmit: () => void
  isSubmitting: boolean
}

const GroupMembersUpdateDialog = (props: Props) => {
  const {members, formValues, usersToRemove, ...rest} = props

  const usersToAdd = formValues.newUsers
    .filter(user => user.firstName && user.lastName && user.email)
    .map(user => user.email!)

  const actualUsersToRemove =
    props.formValues.addUsers === '2' && members
      ? members.filter(member => !member.isAdmin).map(member => member.email)
      : usersToRemove

  return (
    <View
      {...rest}
      usersToAdd={usersToAdd}
      usersToRemove={actualUsersToRemove}
      isFullImport={formValues.addUsers === '2'}
    />
  )
}

export default GroupMembersUpdateDialog
